import { DetailWrapper } from "../../../../../features/ui"
import { BudgetDetail } from "./budgetDetail"

export const BudgetDetailLoader = () => (
    <DetailWrapper>
        <BudgetDetail />
    </DetailWrapper>
)
